import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Button } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CompanyQuickSearchComponent from './company/CompanyQuickSearchComponent';
import CompanySearchCondComponent from './company/CompanySearchCondComponent';
import CompanyResultListComponent from './company/CompanyResultListComponent';
import SubMenu from './SubMenu';
import UserMenu from './UserMenu';
import { ROLE_CODE } from '../../common/const';
import {
  disAuthenticate,
  setSystemLodingFLg,
} from '../actions/CommonAction';
import './Header.css';
import HeaderLogo from '../../image/logo_t_marketing.svg';
import UserIcon from '../../image/user_icon.png';
import CompanySelectedComponent from './company/CompanySelectedComponent';
import MessageArea from './MessageArea';

/**
 * 共通ヘッダコンポーネント
 */
class Header extends Component {
  componentDidMount() {
    // マウス操作イベントにサブメニューの表示・非表示の制御を設定
    const elem1 = document.getElementsByClassName('menu');
    if (elem1 && elem1.length > 0) {
      elem1[0].addEventListener('mouseover', () => {
        this.dispSubmenu(true);
        this.dispBalloon(true);
      });
      elem1[0].addEventListener('mouseout', () => {
        this.dispSubmenu(false);
        this.dispBalloon(false);
      });
    }
    const elem2 = document.getElementsByClassName('userinfofield');
    let isVisible = false;
    let oldVisible;
    if (elem2 && elem2.length > 0) {
      elem2[0].addEventListener('click', () => {
        oldVisible = isVisible;
        isVisible = !isVisible;
        this.dispUsermenu(isVisible);
        this.dispBalloon(isVisible);
      });
    }

    document.addEventListener('click', () => {
      if (isVisible === oldVisible && isVisible) {
        isVisible = false;
        this.dispUsermenu(false);
        this.dispBalloon(false);
      } else {
        oldVisible = isVisible;
      }
    });
  }

  /**
   * サブメニューの表示制御
   */
  dispSubmenu = (flag) => {
    const elem = document.getElementsByClassName('submenufield');
    if (elem && elem.length > 0) {
      if (flag) {
        elem[0].classList.add('sub-active');
      } else {
        elem[0].classList.remove('sub-active');
      }
    }
  }

  /**
   * ユーザーメニューの表示制御
   */
  dispUsermenu = (flag) => {
    const elem = document.getElementsByClassName('usermenufield');
    if (elem && elem.length > 0) {
      if (flag) {
        elem[0].classList.add('sub-active');
      } else {
        elem[0].classList.remove('sub-active');
      }

      const elem2 = document.getElementsByClassName('usermenu');
      if (elem2 && elem2.length > 0) {
        if (flag) {
          elem2[0].classList.add('sub-active');
        } else {
          elem2[0].classList.remove('sub-active');
        }
      }
    }
  }

  /**
   * 吹き出しの背面表示制御
   */
  dispBalloon = (flag) => {
    const elemB1 = document.querySelector('.companyDownloadList .button .balloon1 .bubble');
    const elemB2 = document.querySelector('.companyDownloadList .button .balloon2 .bubble');
    if (elemB1) {
      if (flag) {
        elemB1.classList.add('sub-active');
      } else {
        elemB1.classList.remove('sub-active');
      }
    }
    if (elemB2) {
      if (flag) {
        elemB2.classList.add('sub-active');
      } else {
        elemB2.classList.remove('sub-active');
      }
    }
  }

  render() {
    const {
      history,
      userInfo,
    } = this.props;
    const path = history && history.location && history.location.pathname;

    // 企業検索
    let searchcompany = '';
    if (userInfo.role_list.indexOf(ROLE_CODE.COMPANY) >= 0) {
      searchcompany = path === '/searchcompany'
        ? (
          <Button className="mainButton active" disabled>
            系列企業ツリー
            <FiberManualRecordIcon />
          </Button>
        )
        : (
          <Button className="mainButton" component={Link} to="/searchcompany">
            系列企業ツリー
          </Button>
        );
    }
    // ターゲット検索
    let targetcompany = '';
    if (userInfo.role_list.indexOf(ROLE_CODE.TARGET) >= 0) {
      targetcompany = path === '/targetcompany'
        ? (
          <Button className="mainButton active" disabled>
            ターゲティング
            <FiberManualRecordIcon />
          </Button>
        )
        : (
          <Button className="mainButton" component={Link} to="/targetcompany">
            ターゲティング
          </Button>
        );
    }
    // マッチング機能
    let matchingcompanyinfo = '';
    if (userInfo.role_list.indexOf(ROLE_CODE.MATCHING) >= 0) {
      matchingcompanyinfo = path === '/matchingcompany'
        ? (
          <Button className="mainButton active" disabled>
            マッチング
            <FiberManualRecordIcon />
          </Button>
        )
        : (
          <Button className="mainButton" component={Link} to="/matchingcompany">
            マッチング
          </Button>
        );
    }
    // 管理者メニュー
    let adminmenu = '';
    if (
      userInfo.role_list.indexOf(ROLE_CODE.USERMANAGED) >= 0
      || (userInfo.role_list.indexOf(ROLE_CODE.EXTERNALDATA) >= 0
        && (userInfo.businesscard_contact === 1 || userInfo.common_contract === 1))
      || (userInfo.role_list.indexOf(ROLE_CODE.UPLOAD) >= 0
        && userInfo.transaction_contact === 1)
      || userInfo.role_list.indexOf(ROLE_CODE.LOGOUTPUT) >= 0
    ) {
      adminmenu = path === '/uploadcompanyinfo'
      || path === '/usermanaged'
      || path === '/logoutput'
      || path === '/externaldata'
        ? (
          <div className="menu">
            <span className="title active">
              管理者メニュー
            </span>
            <FiberManualRecordIcon />
            <SubMenu />
          </div>
        )
        : (
          <div className="menu">
            <span className="title">
              管理者メニュー
            </span>
            <SubMenu />
          </div>
        );
    }

    // ユーザー名
    let userName;
    if (userInfo) {
      if (userInfo.user_name && userInfo.user_name.length > 15) {
        userName = userInfo.user_name.substr(0, 15).concat('...');
      } else {
        userName = userInfo.user_name;
      }
    }

    return (
      <header>
        <div className={`${path}` === '/searchcompany' ? 'rowCompany' : ' row'}>
          <div className="leftfield">
            {/* タイトルフィールド */}
            <div className="titlefield">
              <img alt="HeaderLogo" src={HeaderLogo} />
            </div>
            {/* メニューフィールド */}
            <div className="menufield">
              <div className="headerButtonField">
                {searchcompany}
                {targetcompany}
                {matchingcompanyinfo}
                {adminmenu}
              </div>
            </div>
          </div>
          {/* ユーザーメニューフィールド */}
          <div className="userinfofield">
            <div className="userIconSircle">
              <img alt="UserIcon" src={UserIcon} />
            </div>
            <div className="id">{userInfo ? userName : ''}</div>
            {userInfo.user_name && userInfo.user_name.length > 15 && (<div className="usernamedescription">{userInfo.user_name}</div>)}
            <div className="usermenu">
              { this.dispUsermenu === true
                ? <ArrowDropUpIcon />
                : <ArrowDropDownIcon />}
            </div>
            <UserMenu />
          </div>
        </div>
        {/* 検索ボックスのコンポーネント */}
        {`${path}` === '/searchcompany'
        && (
        <div className="underfield">
          <div><MessageArea /></div>
          <div className="greensircle">
            <div className="lightgreensircle" />
          </div>
          <div className="searchfield">
            <CompanyQuickSearchComponent />
          </div>
        </div>
        )}
        {/* 検索条件詳細のコンポーネント */}
        <CompanySearchCondComponent />
        {/* 企業検索結果一覧のコンポーネント */}
        <CompanyResultListComponent />
        {/* サブメニューのコンポーネント */}
        {`${path}` === '/searchcompany'
        && (
          <div className="headerfield">
            <CompanySelectedComponent />
          </div>
        )}
      </header>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    disAuthenticateAct: () => dispatch(disAuthenticate()),
    setSystemLodingFLgAct: (systemLodingFLg) => dispatch(setSystemLodingFLg(systemLodingFLg)),
  }),
)(withRouter(Header));
